import * as React from "react";
import { DropdownPrimary } from "../../../../../react-core/Html/DropdownPrimary";
import { MenuItem } from "../../../../../Wrap/Models/Domains/Menu/MenuItem";
import { Objects } from "../../../../../react-core/Utils/Objects";
import { IconMap } from "../Entities/IconMap";
import { SubaccountSideMenuMap } from "../Entities/SubaccountSideMenuMap";
import { isNullOrEmpty } from "../../../../../react-core/Utils/Arrays";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { StaticUrls } from "../../../Resoures/StaticUrls";
import { ClientAccountStore, PensionSubAccountSettingsStore, UserStore } from "../../../Stroes/Variable";
import { BaseComponent } from "../../../../../react-core/Html/BaseComponent";
import { SideMenu } from "../../../../../Wrap/Constants/Enums/Menu/SideMenu";
import * as classNames from "classnames";
import { AllLevelRestrictionStore, RestrictionStore } from "../../Clients/Common/Restrictions/Variable";
import { Lightbox, LightboxType } from "../../../../../react-core/Html/Components/Lightbox";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../Shared/Permission/PermissionHelper";
import { BusinessManagementPropositionStore } from "../../BusinessManagement/Store/Variable";
import {
    ServiceProposition,
    ServiceProposition as ServicePropositionEnum,
} from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { IActionMenuParamsModel, subAccountActionMenu } from "../IParameterModel";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { ContextStore } from "../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../Wrap/Constants/Enums/ContextType";
import { TrustDetail } from "../../../../../Wrap/Models/Domains/Account/TrustDetail";
import { subMenuLabels } from "../../../Resoures/Contents";
import { setActionMenuParams } from "../../../../DLU/DLUHelper";
import { PortfolioRegularPayment } from "../../../../../Wrap/Models/Domains/Valuation/PortfolioRegularPayment";
import { CustomerType } from "../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { Organisation } from "../../../../../Wrap/Models/Models/Customer/Organisation";
import { ClientRecordTab } from "../../Clients/ClientRecord/Resource/Contents";
import { ClientRecordStore } from "../../Clients/ClientRecord/Store/Variable";
import { OldNewTrustWizard } from "../../Clients/AddClient/Resource/Contents";
import { PortfolioViewMenuAdditionalInfoStore } from "../Store/Variable";
import { findHeadAccount } from "../../Clients/PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { PersonalDetail } from "../../../../../Wrap/Models/Models/Customer/PersonalDetail";
import { ProcessType } from "../../../../Shared/IST/Resource/Content";
import { WizardLinkRestriction } from "../../Clients/Common/Restrictions/WizardLinkRestriction";
import { SubAccountTypeHelper } from "../../Clients/Common/Helpers/SubAccountTypeHelper";
import { AccountStatus } from "../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { Action } from "../../../Actions/Action";
import { CashPaymentTypeQuery } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery";
import { CashPaymentFrequencyQuery } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { CashPayment } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { PaymentSource } from "../../../../../Wrap/Constants/Enums/Domain/PaymentSource";
import { SelectRegularPaymentPop } from "../../Clients/PortfolioDashboard/Components/Common/SelectRegularPaymentPop";
import { InstructionType } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/InstructionType";
import { PaymentStatus } from "../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/PaymentStatus";
import { FsaPermission } from "../../../../../Wrap/Models/Models/Company/FsaPermission";
import { TransactionEnum } from "../../Clients/PortfolioDashboard/Components/Transactions/Resource/Contents";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ignoreExisitingRegularPaymentForSubAccountSubTypes } from "../../Clients/RegularPaymentWizard/Resource/Constants";
import { RestrictionReason } from "../../../../../Wrap/Models/Models/Account/Restrictions/RestrictionReason";
import { RestrictionReasonStore } from "../../Clients/PortfolioDashboard/Store/Variables";
import { SubAccountWizardLinkRestriction } from "../../Clients/Common/Restrictions/SubAccountWizardLinkRestriction";
import { DashboardAction } from "../../Dashboard/Action/DashboardAction";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { ActivityStatus } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ActivityStatus";
import { ProcessType as WorkflowProcessType } from '../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType';
import { PensionSubAccountSettings } from "../../../../../Wrap/Models/Domains/SubAccount/PensionSubAccountSettings";
import { isEmpty } from "lodash";
import { ErrorMessageContents } from "../Resource/Contents";
import { useRestrictionActivitiesHook } from "../../Clients/Common/Restrictions/useRestrictionActivitiesHook";
import { RestrictionAction } from "../../Clients/Common/Restrictions/RestrictionAction";


interface INavigationSectionsProps {
    navigationConfig: MenuItem[];
    heading?: string;
    onHierarchyIdClick: (sideMenu: SideMenu, hiercharyId: string) => void;
    sideMenu: SideMenu;
    urlParams: IActionMenuParamsModel;
    trustDetail: TrustDetail;
    productdetail: PortfolioRegularPayment;
    accountStatus: AccountStatus;
    headClAccountId: string;
    companyFsaPermission: FsaPermission[];
}
interface INavigationSectionsStates {
    showLightbox: boolean;
    errorMsg: string;
    clientdetail: PersonalDetail;
    clientRegularPayment: CashPayment[];
    multiPaymentType: ProcessType;
    restrictionReasons: RestrictionReason[];
    isPensionProcessingRestriction:Boolean;
    isPensionSubAccountSettingsLoading?: boolean;
    pensionSubAccountSettings: PensionSubAccountSettings;
    tpbIncompleteActivityExists: boolean;
}

export class NavigationSections extends BaseComponent<INavigationSectionsProps, INavigationSectionsStates> {
    constructor(props: null) {
        super(props);
        this.state = {
            showLightbox: false,
            errorMsg: "",
            clientdetail: ClientRecordStore.getData()?.[ClientRecordTab.PersonalDetail],
            clientRegularPayment: [],
            multiPaymentType: null,
            restrictionReasons:RestrictionReasonStore.getData(),
            isPensionProcessingRestriction:this.isPensionProcessRestriction(RestrictionReasonStore.getData()),
            isPensionSubAccountSettingsLoading: false,
            pensionSubAccountSettings: PensionSubAccountSettingsStore.getPensionSubAccountSettings(),
            tpbIncompleteActivityExists: false
        };
        this.subscribeToStore(ClientRecordStore, () => {
            this.setState({ clientdetail: ClientRecordStore.getData()?.[ClientRecordTab.PersonalDetail] });
        });
        this.subscribeToStore(RestrictionReasonStore, () => this.onRestrictionReasonStoreChange());
        this.subscribeToStore(PensionSubAccountSettingsStore, () => {
            this.setState({ 
                isPensionSubAccountSettingsLoading: PensionSubAccountSettingsStore.isLoading(),
                pensionSubAccountSettings: PensionSubAccountSettingsStore.getPensionSubAccountSettings(), 
            });
        });
    }
    
    public componentDidMount() {
        const { urlParams } = this.props;
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        const subaccount = (clientAccount?.SubAccounts || []).find(
            (ele) => ele.HierarchyId == urlParams.subaccountHierarchyId
        );
        
        if (subaccount && (subaccount.SubAccountType == SubAccountType.Npr || subaccount.SubAccountType == SubAccountType.JuniorSipp)) {
            DashboardAction.getWorkflowTable({
                activity: WorkflowProcessType.TakePensionBenefit,
                status: ActivityStatus.Pending,
                product: [subaccount.SubAccountType],
                endDate: JsonDateParser.toJsonDateNoOffset(new Date()),
                beginDate: JsonDateParser.toJsonDateNoOffset(new Date(new Date().setFullYear(new Date().getFullYear() - 1))),
                start: 1,
                count: 1,
                customerId: HierarchyIdHelper.generateHierarchyId(ContextStore.getUrlParamsHierarchyId(ContextType.Customer)).entityId,
                headAccountHierarchyIds: [clientAccount.HierarchyId],
                subAccountHierarchyIds: [urlParams.subaccountHierarchyId],
            }, (result) => {
                this.setState({ tpbIncompleteActivityExists: result.TotalNumberOfResults > 0 });
            });
            DashboardAction.loadPensionSubAccountSettings(subaccount.HierarchyId);
        }
        
        if (!AllLevelRestrictionStore.isLoading()) {
            RestrictionAction.getAllLevelRestrictionByHierarchyId(urlParams.subaccountHierarchyId);
        }

    }
    
    private onRestrictionReasonStoreChange(): void {
        const data = RestrictionReasonStore.getData();
        const isPensionProcessing = this.isPensionProcessRestriction(data);
        this.setState({ restrictionReasons: data, isPensionProcessingRestriction: isPensionProcessing });
    }

    private isPensionProcessRestriction = (restrictedReasons:RestrictionReason[]) : Boolean =>
        {
            let isPensionProcessRestrinction : Boolean = false;
            if(restrictedReasons && restrictedReasons?.length > 0){
                restrictedReasons.map( x => 
                    {
                        if(x.ReasonName == "Pension Processing"){
                            isPensionProcessRestrinction = true;
                            return;   
                        }
                    });
            }
            return isPensionProcessRestrinction;
    };

    private isDpcNprAccount(): boolean {
        return this.state.pensionSubAccountSettings?.HasDisqualifyingPensionCredit ?? false;
    }

    private transactionurl = (view: TransactionEnum) => {
        return StaticUrls.transactionViewsUrls(
            ContextStore.getUrlParamsHierarchyId(ContextType.Customer) ?? this.props.urlParams.levelHierarchyId,
            view,
            this.props.urlParams.headaccounthierarchyId
        );
    };

    private nativeHrefClick = (event: React.MouseEvent<HTMLElement>, url: string) => {
        if (
            url.indexOf("/client/new-business/full-client-detail") > 0 &&
            url.indexOf("hierarchyid") > 0 &&
            this.props.accountStatus !== AccountStatus.Active
        ) {
            event.preventDefault();
            this.setState({
                showLightbox: true,
                errorMsg: "You can not process this action until the account is active.",
            });
            return false;
        }
        setActionMenuParams(this.props.urlParams);
    };

    private getPensionActivitiesSuspendedInfo = () => {
        const { urlParams } = this.props;
        const allAccounts =
            PortfolioViewMenuAdditionalInfoStore.getData()?.UnderlyingClientAccount ||
            (ClientAccountStore.getClientAccountInfo() ? [ClientAccountStore.getClientAccountInfo()] : []);
        const headAccount = findHeadAccount(
            allAccounts,
            urlParams.headaccounthierarchyId || urlParams.subaccountHierarchyId
        );
        const hook = useRestrictionActivitiesHook();
        const nprSubClAccountId = headAccount?.SubAccounts?.find(x => x.WrapperType === SubAccountType.Npr)?.ClAccountId;
        const isPensionActivitiesBeenSuspended = headAccount ? hook.isPensionActivitiesBeenSuspended(headAccount.HeadClAccountId, nprSubClAccountId) : false;
        const getPensionActivitiesSuspendedMsg = () => {
            return headAccount && hook.isBlockedByPensionProcessingRestriction(headAccount.HeadClAccountId, nprSubClAccountId) 
            ? ErrorMessageContents.SubAccountWizardLinkRestricted
            : ErrorMessageContents.PensionActivitiesSuspended;
        }
        return {
            isPensionActivitiesBeenSuspended,
            getPensionActivitiesSuspendedMsg
        };
    }

    private itemIsDropdown(item: MenuItem, key: number) {
        const {
            isPensionActivitiesBeenSuspended,
            getPensionActivitiesSuspendedMsg
        } = this.getPensionActivitiesSuspendedInfo();
        const storeData: ServiceProposition[] = BusinessManagementPropositionStore.getData();
        if (
            this.props.sideMenu == SideMenu.BusinessManagement &&
            (storeData || []).filter((x) => x == ServicePropositionEnum.Fundzone).length > 0 &&
            item.MenuCaption == "Mandates"
        ) {
            return null;
        } else
            {return (
                <div key={key} className={"add" + key}>
                    <DropdownPrimary label={item.MenuCaption} cssWrapper="is-nav-dropdown" cssButton={"ad d" + key}>
                        {item.SubMenu.map((dropitem: MenuItem, key: number) => {
                            /**
                             * Transaction dropdown
                             */

                            if (dropitem?.MenuCaption == "Edit adviser access") {
                                const url = dropitem.Url;
                                return (
                                    <a
                                        onClick={() => {
                                            setActionMenuParams(this.props.urlParams);
                                        }}
                                        key={key}
                                        className="item"
                                        href={url}
                                    >
                                        {dropitem?.MenuCaption}
                                    </a>
                                );
                            }
                            if (dropitem?.MenuCaption == "Investments") {
                                return (
                                    <a
                                        key={key}
                                        className="item"
                                        href={this.transactionurl(TransactionEnum.investments)}
                                    >
                                        {dropitem?.MenuCaption}
                                    </a>
                                );
                            }
                            if (dropitem?.MenuCaption == "Cash") {
                                return (
                                    <a key={key} className="item" href={this.transactionurl(TransactionEnum.cash)}>
                                        {dropitem?.MenuCaption}
                                    </a>
                                );
                            }
                            if (dropitem?.MenuCaption == "Payments/withdrawal") {
                                return (
                                    <a
                                        key={key}
                                        className="item"
                                        href={this.transactionurl(TransactionEnum.paymentsWithdrawals)}
                                    >
                                        {dropitem?.MenuCaption}
                                    </a>
                                );
                            }
                            if (dropitem?.MenuCaption == "Account transfer") {
                                return (
                                    <a
                                        key={key}
                                        className="item"
                                        href={this.transactionurl(TransactionEnum.accountTransfers)}
                                    >
                                        {dropitem?.MenuCaption}
                                    </a>
                                );
                            }
                            if (dropitem?.MenuCaption == "Corporate actions") {
                                return (
                                    <a
                                        key={key}
                                        className="item"
                                        href={this.transactionurl(TransactionEnum.corporateActions)}
                                    >
                                        Dividend summary
                                    </a>
                                );
                            }
                            if (dropitem?.MenuCaption == "Other corporate actions") {
                                return (
                                    <a
                                        key={key}
                                        className="item"
                                        href={this.transactionurl(TransactionEnum.otherCorporateActions)}
                                    >
                                        {dropitem?.MenuCaption}
                                    </a>
                                );
                            }
                            if (dropitem?.MenuCaption == "Charges") {
                                return (
                                    <a key={key} className="item" href={this.transactionurl(TransactionEnum.charges)}>
                                        {dropitem?.MenuCaption}
                                    </a>
                                );
                            }
                            if (dropitem?.MenuCaption == "Take pension benefits") {
                                return (
                                    <a
                                        key={key}
                                        className="item"
                                        onClick={() => {
                                            if (RestrictionStore.WithdrawDisabled()) {
                                                this.setState({ showLightbox: true });
                                            }
                                        }}
                                        href="javascript:void(0);"
                                    >
                                        {dropitem?.MenuCaption}
                                    </a>
                                );
                            }
                            if (dropitem?.MenuCaption == subMenuLabels.newBusinessLabel) {
                                return (
                                    <a
                                        key={key}
                                        className="item"
                                        onClick={() => {
                                            if (
                                                !this.props.trustDetail ||
                                                this.props.trustDetail?.TrustType == "GIFTPLAN" ||
                                                this.props.trustDetail?.NewOrExistingTrust == "Existing"
                                            ) {
                                                window.location.assign(dropitem.Url);
                                            } else {
                                                this.setState({
                                                    showLightbox: true,
                                                    errorMsg:
                                                        "New product journey not available for this type of Account.",
                                                });
                                            }
                                        }}
                                        href="javascript:void(0);"
                                    >
                                        {dropitem?.MenuCaption}
                                    </a>
                                );
                            }
                            
                            if (dropitem?.MenuCaption == "Configure my Client Portal") {
                                const companyId = UserStore.getUserInfo()?.CompanyId;
                                const hierarchy = HierarchyIdHelper.toHierarchyIdString(
                                    HierarchyLevelName.Company,
                                    companyId
                                );
                                const url = `/wpadviser/en-gb/customer/home/${hierarchy}/landingpage?hierarchyId=${hierarchy}`;
                                return (
                                    <a
                                        key={key}
                                        className="item"
                                        onClick={() => {
                                            setActionMenuParams(this.props.urlParams);
                                        }}
                                        href={url}
                                    >
                                        {dropitem?.MenuCaption}
                                    </a>
                                );
                            }
                            
                            if (dropitem?.MenuCaption.includes("GAD review") && isPensionActivitiesBeenSuspended) {
                                return (
                                    <a
                                                key={key}
                                                className="item"
                                                onClick={() => {
                                                    this.setState({
                                                        showLightbox: true,
                                                        errorMsg: getPensionActivitiesSuspendedMsg()
                                                    });
                                                }}
                                                href="javascript:void(0);"
                                            >
                                                {dropitem?.MenuCaption}
                                            </a>
                                );
                            }

                            return (
                                <a
                                    key={key}
                                    className="item"
                                    onClick={() => {
                                        setActionMenuParams(this.props.urlParams);
                                    }}
                                    href={
                                        dropitem?.Url
                                            ? CommonHelper.ReplaceSpecialSymbols(dropitem?.Url)
                                            : "javascript:void(0);"
                                    }
                                >
                                    {dropitem?.MenuCaption}
                                </a>
                            );
                        })}
                    </DropdownPrimary>
                </div>
            );}
    }
    private itemIsLink(item: MenuItem, key: number) {
        if (item && item.MenuCaption == "Legacy client reports") {
            let url = CommonHelper.ReplaceSpecialSymbols(item.Url);
            if (!url.includes("customerhierarchyid")) {
                url = url + "&customerhierarchyid=" + ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
            }
            return (
                <a
                    key={key}
                    className={"custom-item ad d" + key}
                    href={url}
                    onClick={() => {
                        setActionMenuParams(this.props.urlParams);
                    }}
                >
                    {item.MenuCaption}
                </a>
            );
        }

        if (item.HierarchyId) {
            return (
                <button
                    key={key}
                    className={"custom-item ad d" + key}
                    onClick={() => {
                        const type = HierarchyIdHelper.generateHierarchyId(item.HierarchyId).hierarchyLevel;
                        if (type == HierarchyLevelName.SubAccount) {
                            const selectedSideMenu = SubaccountSideMenuMap.getSubaccountSideMenu(item.MenuCaption);
                            this.props.onHierarchyIdClick(selectedSideMenu, item.HierarchyId);
                        } else if (type == HierarchyLevelName.Account) {
                            this.props.onHierarchyIdClick(SideMenu.Portfolio, item.HierarchyId);
                        }
                    }}
                >
                    {item.MenuCaption}
                </button>
            );
        } else if (
            subAccountActionMenu.includes(this.props.sideMenu) ||
            [SideMenu.Portfolio, SideMenu.Account, SideMenu.ConsolidatedAccount].includes(this.props.sideMenu)
        ) {
            return this.generateDataForSubAccount(item, key);
        } else if (item.MenuCaption == "Create/Edit Links") {
            return (
                <a key={key} className={"custom-item ad d" + key} href={CommonHelper.ReplaceSpecialSymbols(item.Url)}>
                    {"Add/Edit family discounts"}
                </a>
            );
        } else {
            return (
                <a key={key} className={"custom-item ad d" + key} onClick={() => setActionMenuParams(this.props.urlParams)} href={CommonHelper.ReplaceSpecialSymbols(item.Url)}>
                    {item.MenuCaption}
                </a>
            );
        }
    }

    private getSections() {
        const sections: MenuItem[][] = [];
        if (!isNullOrEmpty(this.props.navigationConfig)) {
            const menuList = Objects.cloneObject(this.props.navigationConfig);
            const chunk_size = 4;
            for (let index = 0; index < menuList.length; index += chunk_size) {
                const subArray = menuList.slice(index, index + chunk_size);
                sections.push(subArray);
            }
        }
        return sections;
    }

    public render(): JSX.Element {
        const sections = this.getSections();
        return (
            <>
                {this.state.showLightbox && (
                    <Lightbox
                        show={this.state.showLightbox}
                        title={"Warning"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showLightbox: false, errorMsg: "" })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>{this.state.errorMsg}</p>

                        <button
                            className="btn primary"
                            onClick={() => this.setState({ showLightbox: false, errorMsg: "" })}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
                <SelectRegularPaymentPop
                    clientRegularPayment={this.state.clientRegularPayment}
                    onClose={() => {
                        this.setState({ clientRegularPayment: [] });
                    }}
                    onSelect={(id) => {
                        const clientAccount = ClientAccountStore.getClientAccountInfo();

                        const subaccount = (clientAccount?.SubAccounts || []).find(
                            (ele) => ele.HierarchyId == this.props.urlParams.subaccountHierarchyId
                        );

                        let url = StaticUrls.RegularPaymentUrl(
                            subaccount?.SubAccountType.toString(),
                            subaccount?.ClAccountId,
                            clientAccount?.HierarchyId,
                            subaccount?.HierarchyId,
                            "edit",
                            id
                        );
                        if (this.state.multiPaymentType == ProcessType.WhatIf) {
                            url = StaticUrls.WhatIfToolUrl(
                                subaccount?.SubAccountType.toString(),
                                subaccount?.ClAccountId,
                                clientAccount?.HierarchyId,
                                subaccount?.HierarchyId,
                                id
                            );
                        }
                        window.location.assign(url);
                    }}
                />
                <div className="sections">
                    {sections &&
                        sections.map((section: MenuItem[], key: number) => {
                            return (
                                <div key={key} className="cno-section">
                                    <div className="cno-section-heading">{key == 0 ? this.props.heading : ""}</div>
                                    <div className="row wide-gutter">
                                        {section.map((column: MenuItem, key2: number) => {
                                            const storeData: ServiceProposition[] = BusinessManagementPropositionStore.getData();
                                            if (
                                                this.props.sideMenu == SideMenu.BusinessManagement &&
                                                (storeData || []).some((x) => x == ServicePropositionEnum.Fundzone) &&
                                                column.MenuCaption == "Bulk"
                                            ) {
                                                return null;
                                            } else
                                                {return (
                                                    <div key={key2} className="col-12 col-xs-6 col-sm-4 col-md-3">
                                                        <div className="column">
                                                            <h2
                                                                className={classNames(
                                                                    "cno-column-heading",
                                                                    this.getIcon(column.MenuCaption)
                                                                )}
                                                            >
                                                                <span className="icon" aria-hidden={true} />
                                                                {column.MenuCaption}
                                                            </h2>
                                                            {column.SubMenu &&
                                                                column.SubMenu.map((item: MenuItem, key3: number) => {
                                                                    return !isNullOrEmpty(item.SubMenu)
                                                                        ? this.itemIsDropdown(item, key3)
                                                                        : this.itemIsLink(item, key3);
                                                                }).filter((x) => x != null)}
                                                        </div>
                                                    </div>
                                                );}
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </>
        );
    }

    private getIcon(menuString: string): string {
        return IconMap.getIcon(menuString);
    }

    private generateDataForSubAccount(item: MenuItem, key: number): JSX.Element {
        const { urlParams } = this.props;
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        const productDetail = this.props.productdetail?.ProductPayments;

        const subaccount = (clientAccount?.SubAccounts || []).find(
            (ele) => ele.HierarchyId == urlParams.subaccountHierarchyId
        );
        if (item.MenuCaption == "Take pension benefits" && subaccount && (subaccount.SubAccountType == SubAccountType.Npr || subaccount.SubAccountType == SubAccountType.JuniorSipp) && !this.state?.tpbIncompleteActivityExists) {
            DashboardAction.getWorkflowTable({
                activity: WorkflowProcessType.TakePensionBenefit,
                status: ActivityStatus.Pending,
                product: [subaccount.SubAccountType],
                endDate: JsonDateParser.toJsonDateNoOffset(new Date()),
                beginDate: JsonDateParser.toJsonDateNoOffset(new Date(new Date().setFullYear(new Date().getFullYear() - 1))),
                start: 1,
                count: 1,
                customerId: HierarchyIdHelper.generateHierarchyId(ContextStore.getUrlParamsHierarchyId(ContextType.Customer)).entityId,
                headAccountHierarchyIds: [clientAccount.HierarchyId],
                subAccountHierarchyIds: [urlParams.subaccountHierarchyId],
            }, (result) => {
                this.setState({ tpbIncompleteActivityExists: result.TotalNumberOfResults > 0 });
            });
        }
        const data = (productDetail || []).find((ele) => ele.ClAccountId == subaccount?.ClAccountId)?.Payments || [];
        const allAccounts =
            PortfolioViewMenuAdditionalInfoStore.getData()?.UnderlyingClientAccount ||
            (ClientAccountStore.getClientAccountInfo() ? [ClientAccountStore.getClientAccountInfo()] : []);
        const headAccount = findHeadAccount(
            allAccounts,
            urlParams.headaccounthierarchyId || urlParams.subaccountHierarchyId
        );
        const {
            isPensionActivitiesBeenSuspended,
            getPensionActivitiesSuspendedMsg
        } = this.getPensionActivitiesSuspendedInfo();

        let blockTrustTopupAndWithdrawal = false;
        if (this.props.trustDetail) {
            blockTrustTopupAndWithdrawal = ["loanplan", "discountedgiftplan"].includes(
                (this.props.trustDetail?.TrustType || "").toLowerCase()
            );
        }
        const isDpcNprAccount = this.isDpcNprAccount();

        let disableAllProductByFsa = false;
        const disableSippByFsa = false;
        if (
            SubAccountTypeHelper.isLegacyProduct(subaccount?.SubAccountType) &&
            this.props.companyFsaPermission != null
        ) {
            disableAllProductByFsa = !this.props.companyFsaPermission.some(
                (ele) =>
                    ele?.FsaRegulatedActivity?.Name?.toLowerCase() == "AdviseInvestments".toLowerCase() &&
                    ele.IsInclude &&
                    ele.IsPermit
            );
        }

        if (item.MenuCaption == "Buy") {
            const isBlock = WizardLinkRestriction(headAccount, urlParams.subaccountHierarchyId, ProcessType.Buy);
            let url = StaticUrls.BuyUrl(
                subaccount?.SubAccountType.toString(),
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                subaccount?.HierarchyId
            );
            if (this.props.trustDetail) {
                url = StaticUrls.CreateOrder(subaccount?.ClAccountId);
            }
            return (
                checkPermission(UserClaim.AdviserPortalBuySellSwitchReadWrite) && (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={isBlock ? "javascript:void(0);" : url}
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                                });
                            } else if (this.props.trustDetail) {
                                setActionMenuParams(urlParams);
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                )
            );
        }
        if (item.MenuCaption == "Sell") {
            const isBlock = WizardLinkRestriction(headAccount, urlParams.subaccountHierarchyId, ProcessType.Sell);
            let url = StaticUrls.SellUrl(
                subaccount?.SubAccountType.toString(),
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                subaccount?.HierarchyId
            );
            if (this.props.trustDetail) {
                url = StaticUrls.CreateOrder(subaccount?.ClAccountId);
            }
            return (
                checkPermission(UserClaim.AdviserPortalBuySellSwitchReadWrite) && (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={isBlock ? "javascript:void(0);" : url}
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                                });
                            } else if (this.props.trustDetail) {
                                setActionMenuParams(urlParams);
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                )
            );
        }
        if (item.MenuCaption == "Switch") {
            const isBlock = WizardLinkRestriction(headAccount, urlParams.subaccountHierarchyId, ProcessType.Switch);
            let url = StaticUrls.SwitchUrl(
                subaccount?.SubAccountType.toString(),
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                subaccount?.HierarchyId
            );
            if (this.props.trustDetail) {
                url = StaticUrls.CreateOrder(subaccount?.ClAccountId);
            }
            return (
                checkPermission(UserClaim.AdviserPortalBuySellSwitchReadWrite) && (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={isBlock ? "javascript:void(0);" : url}
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                                });
                            } else if (this.props.trustDetail) {
                                setActionMenuParams(urlParams);
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                )
            );
        }
        if (item?.MenuCaption == "Transaction summary") {
            return (
                <a key={key} className={"custom-item ad d" + key} href={this.transactionurl(TransactionEnum.summary)}>
                    {item?.MenuCaption}
                </a>
            );
        }
        if (item.MenuCaption == "Single payments/transfers") {
            const isBlock = WizardLinkRestriction(
                headAccount,
                urlParams.subaccountHierarchyId,
                ProcessType.SinglePayment
            );

            let url = StaticUrls.SinglePaymentUrl(
                subaccount?.SubAccountType.toString(),
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                subaccount?.HierarchyId
            );

            if (this.props.trustDetail) {
                url = StaticUrls.NBEC(
                    subaccount?.ClAccountId,
                    SubAccountTypeHelper.isLegacyProduct(subaccount?.SubAccountType)
                );
            }
            return (
                checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={
                            isBlock || blockTrustTopupAndWithdrawal || disableAllProductByFsa || disableSippByFsa || isDpcNprAccount
                                ? "javascript:void(0);"
                                : url
                        }
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                                });
                            } else if (disableAllProductByFsa || disableSippByFsa) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.FCAPermissionDenied,
                                });
                            } else if (blockTrustTopupAndWithdrawal) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.TrustRestriction,
                                });
                            } else if (isDpcNprAccount) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.DpcNprAccountDenied,
                                });
                            } else if (this.props.trustDetail) {
                                setActionMenuParams(urlParams);
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                )
            );
        }

        if (item.MenuCaption == "Add regular payment") {
            
            if (data?.length > 0 &&
                !ignoreExisitingRegularPaymentForSubAccountSubTypes.includes(subaccount?.SubAccountType))
            {
                return null;
            }

            if (SubAccountTypeHelper.isBond(subaccount?.SubAccountType)) {
                return null;
            }

            const isBlock = WizardLinkRestriction(headAccount, urlParams.subaccountHierarchyId, ProcessType.AddRegular);
            let url = StaticUrls.RegularPaymentUrl(
                subaccount?.SubAccountType.toString(),
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                subaccount?.HierarchyId,
                "add"
            );
            if (this.props.trustDetail) {
                url = StaticUrls.NBEC(
                    subaccount?.ClAccountId,
                    SubAccountTypeHelper.isLegacyProduct(subaccount?.SubAccountType)
                );
            }
            
            return (
                checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={
                            isBlock || blockTrustTopupAndWithdrawal || disableAllProductByFsa || disableSippByFsa || isDpcNprAccount
                                ? "javascript:void(0);"
                                : url
                        }
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                                });
                            } else if (disableAllProductByFsa || disableSippByFsa) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.FCAPermissionDenied,
                                });
                            } else if (blockTrustTopupAndWithdrawal) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.TrustRestriction,
                                });
                            } else if (isDpcNprAccount) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.DpcNprAccountDenied,
                                });
                            } else if (this.props.trustDetail) {
                                setActionMenuParams(urlParams);
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                )
            );
        }
        if (item.MenuCaption == "Edit regular payment") {
            const isBlock = WizardLinkRestriction(
                headAccount,
                urlParams.subaccountHierarchyId,
                ProcessType.EditRegular
            );
            if (data?.length <= 0) {return null;}
            let url = "javascript:void(0);";
            if (this.props.trustDetail) {
                url = StaticUrls.NBEC(
                    subaccount?.ClAccountId,
                    SubAccountTypeHelper.isLegacyProduct(subaccount?.SubAccountType)
                );
            }
            return (
                checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={url}
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                                });
                            } else if (disableAllProductByFsa || disableSippByFsa) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.FCAPermissionDenied,
                                });
                            } else if (blockTrustTopupAndWithdrawal) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.TrustRestriction,
                                });
                            } else if (isDpcNprAccount) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.DpcNprAccountDenied,
                                });
                            } else if (this.props.trustDetail) {
                                setActionMenuParams(urlParams);
                            } else {
                                Action.getRegularPaymentCashEntry(
                                    urlParams.subaccountHierarchyId,
                                    CashPaymentTypeQuery.Deposit,
                                    CashPaymentFrequencyQuery.Regular,
                                    (result: CashPayment[]) => {
                                        const clientRegularPayment = result.filter(
                                            (cashEntry) =>
                                                (cashEntry.Source == PaymentSource.Employee ||
                                                    cashEntry.Source == PaymentSource.NotSpecified) &&
                                                cashEntry.InstructionType == InstructionType.Standing &&
                                                cashEntry.Status == PaymentStatus.Authorised
                                        );
                                        if (clientRegularPayment.length > 1) {
                                            this.setState({
                                                clientRegularPayment: clientRegularPayment,
                                                multiPaymentType: ProcessType.EditRegular,
                                            });
                                        } else if(SubAccountTypeHelper.isLegacyProduct(subaccount?.SubAccountType)){
                                            url = StaticUrls.NBEC(
                                                subaccount?.ClAccountId,
                                                SubAccountTypeHelper.isLegacyProduct(subaccount?.SubAccountType)
                                            );
                                            window.location.assign(url);
                                        } else {
                                            const url = StaticUrls.RegularPaymentUrl(
                                                subaccount?.SubAccountType.toString(),
                                                subaccount?.ClAccountId,
                                                clientAccount?.HierarchyId,
                                                subaccount?.HierarchyId,
                                                "edit",
                                                clientRegularPayment[0]?.BatchId
                                            );
                                            window.location.assign(url);
                                        }
                                    }
                                );
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                )
            );
        }
        if (item.MenuCaption == "Move assets to new owner") {
            const isBlock = WizardLinkRestriction(
                headAccount,
                urlParams.subaccountHierarchyId,
                ProcessType.MoveAssetsToNewOwner
            );
            return (
                checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={isBlock ? "javascript:void(0);" : item.Url}
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                                });
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                )
            );
        }
        if (item.MenuCaption == "Launch 'What if' tool") {
            const isBlock = WizardLinkRestriction(headAccount, urlParams.subaccountHierarchyId, ProcessType.WhatIf);
            const url = StaticUrls.WhatIfToolUrl(
                subaccount?.SubAccountType.toString(),
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                subaccount?.HierarchyId
            );
            return (
                checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite) && (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={isBlock || isDpcNprAccount ? "javascript:void(0);" : url}
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                                });
                            } else if (isDpcNprAccount) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.DpcNprAccountDenied,
                                });
                            } else {
                                Action.getRegularPaymentCashEntry(
                                    urlParams.subaccountHierarchyId,
                                    CashPaymentTypeQuery.Deposit,
                                    CashPaymentFrequencyQuery.Regular,
                                    (result: CashPayment[]) => {
                                        const clientRegularPayment = result.filter(
                                            (cashEntry) =>
                                                (cashEntry.Source == PaymentSource.Employee ||
                                                    cashEntry.Source == PaymentSource.NotSpecified) &&
                                                cashEntry.InstructionType == InstructionType.Standing &&
                                                cashEntry.Status == PaymentStatus.Authorised
                                        );
                                        if (clientRegularPayment.length > 1) {
                                            this.setState({
                                                clientRegularPayment: clientRegularPayment,
                                                multiPaymentType: ProcessType.WhatIf,
                                            });
                                        } else if (
                                            checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite)
                                        ) {
                                            const url = StaticUrls.WhatIfToolUrl(
                                                subaccount?.SubAccountType.toString(),
                                                subaccount?.ClAccountId,
                                                clientAccount?.HierarchyId,
                                                subaccount?.HierarchyId,
                                                clientRegularPayment[0]?.BatchId
                                            );
                                            window.location.assign(url);
                                        }
                                    }
                                );
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                )
            );
        }
        if (item.MenuCaption == "No change illustration") {
            const isBlock = WizardLinkRestriction(headAccount, urlParams.subaccountHierarchyId, ProcessType.NoChange);
            const url = StaticUrls.NoChangeToolUrl(
                subaccount?.SubAccountType.toString(),
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                subaccount?.HierarchyId
            );
            return (
                checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={isBlock ? "javascript:void(0);" : url}
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                                });
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                )
            );
        }

        if (item.MenuCaption == "Edit income drawdown") {
            const isWithdrawalDisabled = RestrictionStore.WithdrawDisabled();
            if (isPensionActivitiesBeenSuspended || isWithdrawalDisabled || isDpcNprAccount) {
                return (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        onClick={() => {
                            if(isWithdrawalDisabled) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: "An account with suspended or restricted activities cannot setup withdrawals.",
                                });
                            } else if(isPensionActivitiesBeenSuspended) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: getPensionActivitiesSuspendedMsg()
                                });
                            } else if(isDpcNprAccount) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.DpcNprAccountDenied,
                                });
                            }
                        }}
                        href="javascript:void(0);"
                    >
                        {item.MenuCaption}
                    </a>
                );
            }
        }

        if (item.MenuCaption == "Cancel tailored drawdown" && 
            (WizardLinkRestriction(headAccount, urlParams.subaccountHierarchyId, ProcessType.CancelRegularCrystallisation) || isPensionActivitiesBeenSuspended) ) {
            return (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        onClick={() => {
                            this.setState({
                                showLightbox: true,
                                errorMsg: isPensionActivitiesBeenSuspended
                                ? getPensionActivitiesSuspendedMsg()
                                : ErrorMessageContents.InActiveAccountRestriction,
                            });
                        }}
                        href="javascript:void(0);"
                    >
                        {item.MenuCaption}
                    </a>
                );
            
        }

        if (item.MenuCaption == "Edit income payments") {
            if (isPensionActivitiesBeenSuspended || isDpcNprAccount) {
                return (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        onClick={() => {
                            if (isPensionActivitiesBeenSuspended) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: getPensionActivitiesSuspendedMsg()
                                });
                            } else if (isDpcNprAccount) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.DpcNprAccountDenied,
                                });
                            }
                        }}
                        href="javascript:void(0);"
                    >
                        {item.MenuCaption}
                    </a>
                );
            }
        }

        if (item.MenuCaption == "One-off income payment") {
            if (isPensionActivitiesBeenSuspended || isDpcNprAccount) {
                return (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        onClick={() => {
                            if (isPensionActivitiesBeenSuspended) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: getPensionActivitiesSuspendedMsg()
                                });
                            } else if (isDpcNprAccount) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.DpcNprAccountDenied,
                                });
                            }
                        }}
                        href="javascript:void(0);"
                    >
                        {item.MenuCaption}
                    </a>
                );
            }
        }
        
        if (item.MenuCaption == "Convert Capped to Flexible Drawdown" && isPensionActivitiesBeenSuspended) {
            return (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        onClick={() => {
                            this.setState({
                                showLightbox: true,
                                errorMsg: getPensionActivitiesSuspendedMsg(),
                            });
                        }}
                        href="javascript:void(0);"
                    >
                        {item.MenuCaption}
                    </a>
                ); 
        }

        if (item.MenuCaption == "Gad review"  && isPensionActivitiesBeenSuspended) {
            return (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        onClick={() => {
                            this.setState({
                                showLightbox: true,
                                errorMsg: getPensionActivitiesSuspendedMsg(),
                            });
                        }}
                        href="javascript:void(0);"
                    >
                        {item.MenuCaption}
                    </a>
                ); 
        }
        if (item.MenuCaption == "Take pension benefits") {
            const isBlocked = WizardLinkRestriction(headAccount, urlParams.subaccountHierarchyId, ProcessType.TakePensionBenefits) 
                 || isPensionActivitiesBeenSuspended;
            const isTpbIncompleteActivityExists = this.state?.tpbIncompleteActivityExists;
            const isWithdrawDisabled = RestrictionStore.WithdrawDisabled();
            
            const url = StaticUrls.PensionBenefitsUrl(
                subaccount?.SubAccountType.toString(),
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                subaccount?.HierarchyId,
                false
            );

            return (
                <a
                    key={key}
                    className={"custom-item ad d" + key}
                    href={
                        isBlocked || isTpbIncompleteActivityExists || isWithdrawDisabled || isDpcNprAccount
                            ? "javascript:void(0);"
                            : url
                    }
                    onClick={() => {
                        if (isBlocked) {
                            this.setState({
                                showLightbox: true,
                                errorMsg: isPensionActivitiesBeenSuspended
                                    ? getPensionActivitiesSuspendedMsg()
                                    : ErrorMessageContents.InActiveAccountRestriction,
                            });
                        } else if (isDpcNprAccount) {
                            this.setState({
                                showLightbox: true,
                                errorMsg: ErrorMessageContents.DpcNprAccountDenied,
                            });
                        } else if (isTpbIncompleteActivityExists) {
                            this.setState({
                                showLightbox: true,
                                errorMsg: "You cannot process this action due to another In Progress journey.",
                            });
                        } else if (isWithdrawDisabled) {
                            this.setState({
                                showLightbox: true,
                                errorMsg: "An account with suspended or restricted activities cannot setup withdrawals.",
                            });
                        }
                    }}
                >
                    {item.MenuCaption}
                </a>
            );
        }
        if (item.MenuCaption == "Immediate tax-free lump sum") {
            const isBlock = WizardLinkRestriction(
                headAccount,
                urlParams.subaccountHierarchyId,
                ProcessType.SinglePayment
            ) || isPensionActivitiesBeenSuspended;


            let url = StaticUrls.TopupUrl(
                subaccount?.SubAccountType.toString(),
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                subaccount?.HierarchyId
            );

            if (this.props.trustDetail) {
                url = StaticUrls.NBEC(
                    subaccount?.ClAccountId,
                    SubAccountTypeHelper.isLegacyProduct(subaccount?.SubAccountType)
                );
            }
            
            return (
                checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={
                            isBlock || blockTrustTopupAndWithdrawal || disableAllProductByFsa || disableSippByFsa || isPensionActivitiesBeenSuspended || isDpcNprAccount
                                ? "javascript:void(0);"
                                : url
                        }
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: isPensionActivitiesBeenSuspended
                                    ? getPensionActivitiesSuspendedMsg()
                                    : ErrorMessageContents.InActiveAccountRestriction,
                                });
                            } else if(isDpcNprAccount) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.DpcNprAccountDenied,
                                });
                            } else if (disableAllProductByFsa || disableSippByFsa) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.FCAPermissionDenied,
                                });
                            } else if (blockTrustTopupAndWithdrawal) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.TrustRestriction,
                                });
                            } else if (this.props.trustDetail) {
                                setActionMenuParams(urlParams);
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                )
            );
        }
        if (item.MenuCaption == "PP to S&S ISA") {
            const isBlock = WizardLinkRestriction(
                headAccount,
                urlParams.subaccountHierarchyId,
                ProcessType.MoveAssetsToNewOwner
            );
            const customerId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer) ?? this.props.urlParams.levelHierarchyId;
            const url = StaticUrls.ppToSsIsaUrl(
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                urlParams.subaccountHierarchyId,
                String(HierarchyIdHelper.generateHierarchyId(customerId).entityId)
            );
            return (
                <a
                    key={key}
                    className={"custom-item ad d" + key}
                    href={isBlock ? "javascript:void(0);" : url}
                    onClick={() => {
                        if (isBlock) {
                            this.setState({
                                showLightbox: true,
                                errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                            });
                        } else {
                            setActionMenuParams(urlParams);
                        }
                    }}
                >
                    {item.MenuCaption}
                </a>
            );
        }
        if (item.MenuCaption.toUpperCase() == "PP TO ABERDEEN SIPP") {
            const isBlock = WizardLinkRestriction(
                headAccount,
                urlParams.subaccountHierarchyId,
                ProcessType.MoveAssetsToNewOwner
            );
            const customerId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer) ?? this.props.urlParams.levelHierarchyId;
            const url = StaticUrls.ppToAbrdnSIPPUrl(
                subaccount?.ClAccountId,
                clientAccount?.HierarchyId,
                urlParams.subaccountHierarchyId,
                String(HierarchyIdHelper.generateHierarchyId(customerId).entityId)
            );
            return (
                <a
                    key={key}
                    className={"custom-item ad d" + key}
                    href={isBlock ? "javascript:void(0);" : url}
                    onClick={() => {
                        if (isBlock) {
                            this.setState({
                                showLightbox: true,
                                errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                            });
                        } else {
                            setActionMenuParams(urlParams);
                        }
                    }}
                >
                    {item.MenuCaption}
                </a>
            );
        }
        if (item.MenuCaption == "Withdrawals") {
            const isBlock = WizardLinkRestriction(headAccount, urlParams.subaccountHierarchyId, ProcessType.Withdrawal);
            return (
                <a
                    key={key}
                    className={"custom-item ad d" + key}
                    href="javascript:void(0);"
                    onClick={() => {
                        if (isBlock) {
                            this.setState({
                                showLightbox: true,
                                errorMsg:
                                    "An account with suspended or restricted activities cannot setup withdrawals.",
                            });
                        } else if (blockTrustTopupAndWithdrawal) {
                            this.setState({
                                showLightbox: true,
                                errorMsg: ErrorMessageContents.TrustRestriction,
                            });
                        } else {
                            const url = StaticUrls.WithdrawUrl(subaccount?.ClAccountId);
                            setActionMenuParams(urlParams);
                            window.location.assign(url);
                        }
                    }}
                >
                    {item.MenuCaption}
                </a>
            );
        }

        if (item.MenuCaption == "Create client portfolio report") {
            const url = StaticUrls.createClientPortfolioReportUrl(
                urlParams.levelHierarchyId,
                urlParams.headaccounthierarchyId
            );
            return (
                <a key={key} className={"custom-item ad d" + key} href={url}>
                    {item.MenuCaption}
                </a>
            );
        }
        if (item.MenuCaption == "Existing client new business (including quote)") {
            const isBlock = WizardLinkRestriction(headAccount, urlParams.subaccountHierarchyId, ProcessType.NBEC);
            if (subaccount != null && !CommonHelper.isNullOrEmpty(subaccount?.ClAccountId)) {
                const url = StaticUrls.NBEC(
                    subaccount?.ClAccountId,
                    SubAccountTypeHelper.isLegacyProduct(subaccount?.SubAccountType)
                );
                return (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={isBlock || disableAllProductByFsa || disableSippByFsa ? "javascript:void(0);" : url}
                        onClick={() => {
                            if (isBlock) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.InActiveAccountRestriction,
                                });
                            } else if (disableAllProductByFsa || disableSippByFsa) {
                                this.setState({
                                    showLightbox: true,
                                    errorMsg: ErrorMessageContents.FCAPermissionDenied,
                                });
                            } else {
                                setActionMenuParams(urlParams);
                            }
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                );
            } else {
                return (
                    <a key={key} className={"custom-item ad d" + key} href={"#"} onClick={() => {}}>
                        {item.MenuCaption}
                    </a>
                );
            }
        }
        if (item.MenuCaption == "Add new account") {
            const data = ClientRecordStore.getData();
            if (data != null && !CommonHelper.isNullOrEmpty(data[ClientRecordTab.OrganisationDetails])) {
                const organisation: Organisation = data[ClientRecordTab.OrganisationDetails];
                if (organisation?.CustomerType && organisation?.CustomerType !== CustomerType.Company) {
                    return (
                        <a
                            key={key}
                            className={"custom-item ad d" + key}
                            href={CommonHelper.ReplaceSpecialSymbols(
                                OldNewTrustWizard +
                                    `?customerid=${Number(
                                        ContextStore.getUrlParamsHierarchyId(ContextType.Customer).split("-")[1]
                                    )}`
                            )}
                            onClick={() => {
                                setActionMenuParams(this.props.urlParams);
                            }}
                        >
                            {item.MenuCaption}
                        </a>
                    );
                } else {
                    return (
                        <a key={key} className={"custom-item ad d" + key} href={"#"} onClick={() => {}}>
                            {item.MenuCaption}
                        </a>
                    );
                }
            } else {
                return (
                    <a
                        key={key}
                        className={"custom-item ad d" + key}
                        href={CommonHelper.ReplaceSpecialSymbols(item.Url)}
                        onClick={() => {
                            setActionMenuParams(this.props.urlParams);
                        }}
                    >
                        {item.MenuCaption}
                    </a>
                );
            }
        }
        return (
            <a
                key={key}
                href={CommonHelper.ReplaceSpecialSymbols(item.Url)}
                className={"custom-item ad d" + key}
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                    this.nativeHrefClick(event, CommonHelper.ReplaceSpecialSymbols(item.Url));
                }}
            >
                {item.MenuCaption}
            </a>
        );
    }
}
